<template>
  <div class="profile-exchanges">
    <div class="profile-exchanges__header">
      <div class="profile-exchanges__header__title">Exchanges</div>
      <img
          @click="$router.push('/')"
          src="@/assets/images/svg/close.svg"
          alt="close"
          class="profile-exchanges__header__close"
      />
    </div>

    <div class="profile-exchanges__content">
      <div class="profile-exchanges__content__title">
        <div>Exchanges</div>
        <base-button label="Add API Key" @click="showConnectExchangesModal = true" />
      </div>
      <div class="profile-exchanges__content__main">
        <ConnectExchanges
            v-if="showConnectExchangesModal"
            @close="connectExchangesClose"
        />
        <div v-if="registeredApiKeys && registeredApiKeys.length"
             class="profile-exchanges__content__main__table"
        >
          <div class="profile-exchanges__content__main__table__header">
            <div v-for="(headerItem, index) in headers"
                 :key="index"
                 class="profile-exchanges__content__main__table__header__item"
            > {{ headerItem }} </div>
          </div>
          <div class="profile-exchanges__content__main__table__content">
            <div v-for="registeredApiKey in registeredApiKeys"
                 :key="registeredApiKey.id"
                 class="profile-exchanges__content__main__table__content__line"
            >
              <div class="profile-exchanges__content__main__table__content__line__item">Binance</div>
              <div class="profile-exchanges__content__main__table__content__line__item">{{ registeredApiKey.api_key }}</div>
              <div class="profile-exchanges__content__main__table__content__line__item">{{ registeredApiKey.secret }}</div>
              <div class="profile-exchanges__content__main__table__content__line__item flex">
                <div :class="registeredApiKey.status ? 'connected' : 'offline'"> </div>
                <div> {{ registeredApiKey.status ? 'Connected' : 'Not connected' }} </div>
              </div>
              <div class="profile-exchanges__content__main__table__content__line__item">
                <img src="@/assets/images/svg/delete.svg" @click="deleteBinanceKeys(registeredApiKey.id)" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { AUTO_REFRESH_MS } from "@/constants/apis";
import { deleteBinanceKeys, getBinanceKeys, refreshAllBinanceKeys } from "@/services/account";
import ConnectExchanges from "@/components/ui/shared/modals/connect-exchanges/ConnectExchanges";
import BaseButton from "@/components/ui/atoms/BaseButton";

export default {
  name: "ProfileExchanges",
  components: { BaseButton, ConnectExchanges },
  data() {
    return {
      registeredApiKeys: [],
      showConnectExchangesModal: false,
      headers: ['Exchange', 'API key', 'Secret key', 'Status', 'Actions'],
      setIntervalRef: null
    }
  },
  created() {
    this.getBinanceKeys()

    this.setIntervalRef = setInterval(async () => {
      this.setIsLoading(true)
      await refreshAllBinanceKeys().catch(() => this.setIsLoading(false))
      this.getBinanceKeys()
    }, AUTO_REFRESH_MS)
  },
  beforeDestroy() {
    clearInterval(this.setIntervalRef)
  },
  methods: {
    ...mapActions({
      setIsLoading: 'setIsLoading'
    }),
    getBinanceKeys() {
      this.setIsLoading(true)
      getBinanceKeys()
          .then(data => this.registeredApiKeys = data)
          .catch(({ message }) => this.setSnackbarError(message))
          .finally(() => this.setIsLoading(false))
    },
    async connectExchangesClose() {
      this.showConnectExchangesModal = false
      this.getBinanceKeys()
    },
    deleteBinanceKeys(binanceKeyId) {
      deleteBinanceKeys(binanceKeyId)
          .then(() => this.getBinanceKeys())
          .catch(({ message }) => this.setSnackbarError(message))
    }
  }
};
</script>

<style lang="scss" scoped>
.profile-exchanges {
  display: flex;
  flex-direction: column;

  &__header {
    display: flex;
    justify-content: space-between;
    padding: 1.25rem;
    border-bottom: 0.0625rem solid;

    &__title {
      font-style: normal;
      font-weight: 600;
      font-size: 0.85rem;
    }

    &__close {
      cursor: pointer;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    padding: 0 2.5rem;

    &__title {
      text-align: left;
      font-weight: 600;
      font-size: 1.1rem;
      padding: 2.5rem 0;
      display: flex;
      justify-content: space-between;
      align-items: center;

      button {
        width: 10rem;
        height: 2.5rem;
        line-height: 2.5rem;
      }
    }

    &__main {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 5rem 0;
      margin: 0 auto;

      &__table {
        width: 56rem;
        background: white;
        padding: 1rem;

        &__header, &__content__line {
          display: flex;
          justify-content: space-between;
          text-align: left;

          &:not(:last-child) {
            border-bottom: 0.0625rem solid;
          }

          &__item {
            overflow: hidden;
            text-overflow: ellipsis;
            width: 15%;
            line-height: 100%;
            text-align: center;

            &.flex {
              display: flex;
              justify-content: center;

              .connected, .offline {
                width: 0.5rem;
                height: 0.5rem;
                border-radius: 50%;
                margin-right: 0.25rem;
                margin-top: 0.25rem;
              }

              .connected {
                background: green;
              }

              .offline {
                background: red;
              }

            }

            img {
              cursor: pointer;
              &:first-child {
                margin-right: 1rem;
              }
            }

          }

        }

        &__header {
          color: #868e96;
          font-weight: 500;
          font-size: 1rem;
          padding-bottom: 1.5rem;
          border-bottom: 2px solid #dee2e6;
        }

        &__content__line {
          padding: 1rem 0;

          &:last-child {
            padding-bottom: 0;
          }
        }

      }

    }
  }
}

// only mobile
@media (max-width: 768px) {
  .profile-exchanges {

    &__header {
      justify-content: flex-end;

      &__title {
        display: none;
      }
    }

    &__content__main {
      overflow: hidden;
      max-width: 100%;
      overflow-x: scroll;

      &__table {
        max-width: 38rem;
        overflow-y: scroll;
      }
    }
  }
}
</style>
